import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { DateTimeFormatterPipe } from '../../../shared/pipes/date-time-formatter.pipe';

@Pipe({
  name: 'dateTimeFormatterLabel',
})
export class DateTimeFormatterLabelPipe implements PipeTransform {
  constructor(private dateTimeFormatterPipe: DateTimeFormatterPipe,
              private i18NextPipe: I18NextPipe) {}

  transform(value: string, displayNoDataMessage: boolean, format: string = 'L'): string {
    if (!value && displayNoDataMessage) {
      return this.i18NextPipe.transform('DateTimeFormatterLabelPipe.NoData');
    }

    return this.dateTimeFormatterPipe.transform(value, format);
  }
}
